import script from "./ModalComposition.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalComposition.vue?vue&type=script&setup=true&lang=js"

import "./ModalComposition.vue?vue&type=style&index=0&id=063ad866&lang=scss&scope=true"

const __exports__ = script;

export default __exports__